<template>
  <v-dialog
    :value="active"
    @input="close()"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <v-card>
      <template v-if="details">
        <v-app-bar dark color="#212121" dense fixed>
          <v-btn icon dark @click="close()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title
            >{{ details.chave }} - {{ details.nome }}</v-toolbar-title
          >
        </v-app-bar>
        <v-container fluid pt-12>
          <v-layout row wrap>
            <v-flex xs7 d-flex justify-center row wrap mt-3>
              <v-flex xs12 mr-8 ml-5>
                <Information :details="details" />
              </v-flex>

              <v-flex xs12 mr-8 ml-5 mt-4>
                <Compra :details="details" />
              </v-flex>

              <!-- <v-flex xs12 mr-8 ml-5 mt-4>
                <Pedido :details="details" />
              </v-flex> -->

              <v-flex xs12 mr-8 ml-5 mt-4>
                <Survey :details="details" />
              </v-flex>
            </v-flex>

            <v-flex xs5 mt-3>
              <v-flex v-if="details.Horas_Restantes !== null">
                <v-card>
                  <v-card-title class="justify-center"
                    ><small>
                      Status da Tratativa: {{ details.status }}</small
                    ></v-card-title
                  >
                  <v-card-title class="justify-center font-weight-bold mt-n5"
                    >Contador
                  </v-card-title>

                  <v-card-subtitle class="subheading text-center">{{
                    daysCounter()
                  }}</v-card-subtitle>
                </v-card>
              </v-flex>
              <v-alert type="info">
                Clique em <strong>ATUALIZAR</strong> antes de enviar uma nova
                tratativa.
              </v-alert>
              <Timeline />
            </v-flex>

            <!-- <v-flex xs8>
              <Pedido :details="details" />
            </v-flex> -->

            <!-- <v-row>
              <v-col cols="7" class="pt-0">
                <v-row>
                  <v-col cols="10">
                    <Information :details="details" />
                  </v-col> -->
            <!-- <v-col cols="4" v-if="details.Horas_Restantes !== null">
                  <v-card>
                    <v-card-title class="justify-center font-weight-bold"
                      >Contador</v-card-title
                    >
                    <v-card-subtitle class="subheading text-center">{{
                      daysCounter()
                    }}</v-card-subtitle>
                  </v-card>
                </v-col> -->
            <!-- </v-row>
                <v-row>
                  <v-col cols="10">
                    <Survey :details="details" />
                  </v-col>
                  <v-col cols="5">
                    <Compra :details="details" />
                  </v-col>
                  <v-col cols="5">
                    <Pedido :details="details" />
                  </v-col>
                </v-row>
              </v-col> -->
            <!-- <v-row>
              <v-col cols="16">
                <v-col cols="10" v-if="details.Horas_Restantes !== null">
                  <v-card>
                    <v-card-title class="justify-center font-weight-bold"
                      >Contador</v-card-title
                    >
                    <v-card-subtitle class="subheading text-center">{{
                      daysCounter()
                    }}</v-card-subtitle>
                  </v-card>
                </v-col>
                <v-col cols="10">
                  <Timeline />
                </v-col>
              </v-col>
            </v-row> -->
            <!-- </v-row> -->
          </v-layout>
        </v-container>
      </template>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";

import Information from "@/components/cards/information";
import Compra from "@/components/cards/compra";
// import Pedido from "@/components/cards/pedido";
import Survey from "@/components/cards/survey";
import Timeline from "@/components/cards/timeline";

export default {
  name: "Details",

  components: { Information, Survey, Timeline, Compra },

  computed: {
    ...mapState(["active", "details", "timeline", "loading"]),
  },

  methods: {
    ...mapMutations(["cleanDetails", "setActive"]),
    ...mapActions(["getTimeline"]),

    close() {
      this.setActive({ active: false });
    },
    daysCounter() {
      let days = this.details.Horas_Restantes / 24;
      // console.log("dias", days);
      if (days && days === 1) {
        return "Resta 1 dia para a conclusão da tratativa";
      } else if (days && days > 1) {
        return `Restam ${days} dias para a conclusão da tratativa`;
      } else if (days === 0) {
        // console.log("teste");
        return `Ultimo dia antes do atraso.`;
      } else if (days && days < 0) {
        if (days === -1) {
          return `O registro está ${Math.abs(days)} dia atrasado`;
        }
        return `O registro está ${Math.abs(days)} dias atrasado`;
      }
    },
  },

  watch: {
    active(value) {
      if (value) {
        this.getTimeline();
      } else {
        this.cleanDetails();
      }
    },
  },
};
</script>